import { useEffect, useState } from 'react';
import Card from 'components/atoms/Card';
import Typography from 'components/atoms/Typography';
import Select from 'components/molecules/Select';
import { getAllTemplates } from 'actions/requests';
import { useThunkDispatch } from 'utils/reduxHook';
import { Templates } from 'utils/gloo-types';
import Button from 'components/atoms/Button';

interface KitTemplatesListProps {
  handleSelected: (data: any) => void;
  selected: Templates[];
}

function KitTemplatesList({ handleSelected, selected }: KitTemplatesListProps) {
  const dispatch = useThunkDispatch();
  const [kitTemplates, setKitTemplates] = useState<Templates[]>();

  const templateSelectOptions = (templates) => {
    return templates.map((template) => {
      return { value: template.id, label: template.title, ...template };
    });
  };

  const handleTemplateSelect = (newtemplate) => {
    handleSelected((prevState) => {
      return [...prevState, newtemplate];
    });
  };

  const handleTemplateRemove = (template) => {
    const cleaned = selected.filter((selectedTemplate) => selectedTemplate.id !== template.id);
    handleSelected(cleaned);
  };

  useEffect(() => {
    const loadTemplates = async () => {
      const existingTemplates = await dispatch(getAllTemplates());
      setKitTemplates(existingTemplates);
      if (!selected) {
        handleSelected([]);
      }
    };
    loadTemplates();
  }, []);

  return (
    <>
      {kitTemplates && (
        <Select
          dataDurableId="kitTemplatesListSelectId"
          label="Add An Existing Template"
          options={templateSelectOptions(kitTemplates)}
          onChange={handleTemplateSelect}
          placeholder="Choose Template"
        />
      )}
      {selected &&
        selected.map((selectedTemplate, i) => (
          <Card className="my-2" elevation={2} key={i}>
            <Typography variant="h5">{selectedTemplate.title}</Typography>
            <p className="py-2">{selectedTemplate.shortDescription}</p>
            <Button
              onClick={() => handleTemplateRemove(selectedTemplate)}
              icon="trash"
              dataDurableId="kitTemplateRemoveButton"
              size="xs"
              type="destruction"
              text="Delete"
            />
          </Card>
        ))}
    </>
  );
}

export default KitTemplatesList;
